import { VariantType } from '@enums';
import { forwardRef } from 'react';

import { BaseButton, BaseButtonProps, ContainedButton, OutlinedButton } from '.';

export const Button = forwardRef<HTMLButtonElement, BaseButtonProps>(
  ({ variant = VariantType.Contained, ...props }, ref) => {
    if (variant === VariantType.Contained) {
      return <ContainedButton ref={ref} {...props} />;
    } else if (variant === VariantType.Outlined) {
      return <OutlinedButton ref={ref} {...props} />;
    }

    return <BaseButton ref={ref} {...props} />;
  },
);
